module.exports = {
  title: 'Steps Pager with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-08-13',
  slug: 'steps',
  tags: ['reanimated'],
};
